<div
    #textArea
    class="w-full bg-kiwid-bg-page px-4 py-2 rounded-[6px] font-typography-text-medium overflow-auto"
    [style.max-height]="maxHeight()"
    id="textarea"
    contenteditable="true"
    [attr.aria-placeholder]="placeholder()"
    (keydown)="onKeyDown($event)"
    (paste)="onPaste($event)"
    (input)="onInput($event)"
    (blur)="onBlur($event)"
    aria-hidden="true"
></div>
